import React from 'react';

import {
  TRANSACTION_EVENT_TYPE,
  TRANSACTION_RECORD_TYPE,
} from '../../containers/record/records/TransactionList';
import FilterableDropdown from '../base/FilterableDropdown';
import { CustomTitleLabel } from '../earning/CustomBaseComponments';

function OfflineEventTypeSelectDropdown({
  transactionType,
  selectEventType = () => {},
  defaultEventType,
  defaultDisplayEventType,
  isCreate,
}) {
  const getEventTypeOptions = () => {
    if (transactionType === TRANSACTION_RECORD_TYPE.TYPE_OFFLINE_POS) {
      const offlinePosEventTypes = [
        {
          value: 'PENDING',
          label: TRANSACTION_EVENT_TYPE.TYPE_PENDING,
        },
        {
          value: 'AUTHORIZED',
          label: TRANSACTION_EVENT_TYPE.TYPE_AUTHORIZED,
        },
        {
          value: 'PARTIALLY_PAID',
          label: TRANSACTION_EVENT_TYPE.TYPE_PARTIALLY_PAID,
        },
        {
          value: 'PAID',
          label: TRANSACTION_EVENT_TYPE.TYPE_PAID,
        },
        {
          value: 'PARTIALLY_REFUNDED',
          label: TRANSACTION_EVENT_TYPE.TYPE_PARTIALLY_REFUNDED,
        },
        {
          value: 'REFUNDED',
          label: TRANSACTION_EVENT_TYPE.TYPE_REFUNDED,
        },
        {
          value: 'VOIDED',
          label: TRANSACTION_EVENT_TYPE.TYPE_VOIDED,
        },
      ];
      if (isCreate || defaultEventType === 'EXCHANGE') {
        offlinePosEventTypes.push(
          {
            value: 'EXCHANGE',
            label: TRANSACTION_EVENT_TYPE.TYPE_EXCHANGE,
          },
        );
      }
      return offlinePosEventTypes;
    }
    return [
      {
        value: 'WAITING_FOR_APPROVAL',
        label: TRANSACTION_EVENT_TYPE.TYPE_WAITING,
      },
      {
        value: 'APPROVED',
        label: TRANSACTION_EVENT_TYPE.TYPE_APPROVED,
      },
      {
        value: 'REJECTED',
        label: TRANSACTION_EVENT_TYPE.TYPE_REJECTED,
      },
      {
        value: 'RECALLED',
        label: TRANSACTION_EVENT_TYPE.TYPE_RECALLED,
      },
    ];
  };

  return (
    <>
      <CustomTitleLabel title="Offline event type" />
      <FilterableDropdown
        defaultValue={{
          value: defaultEventType,
          label: defaultDisplayEventType,
        }}
        options={getEventTypeOptions()}
        selectChange={(item) => {
          selectEventType(item);
        }}
        needFilter={false}
      />
    </>
  );
}

export default OfflineEventTypeSelectDropdown;
